import {trackPerformance} from "./actions";
import {call, fork, put, select} from "redux-saga/effects";
import {IApplicationState} from "../index";

let currentMetricId = 1;

type Metrics = {
    category: string;
    action: string;
    startTime: number;
}

const metrics: Record<number, Metrics> = {};

export function* startMetric(category: string, action: string) {
    const metricEnabled = yield select(({ settings }: IApplicationState) => !!settings.performanceMetrics[category]);
    if (!metricEnabled)
        return;

    const metricId = currentMetricId;
    currentMetricId++;

    metrics[metricId] = {
        category: category,
        action: action,
        startTime: new Date().getTime()
    };

    return metricId;
}

export function* endMetric(metricId: number) {
    if (!metricId)
        return;

    const metric = metrics[metricId];
    if (!metric) {
        return;
    }

    const endTime = new Date().getTime();

    yield put(trackPerformance({
        category: metric.category,
        action: metric.action,
        start: metric.startTime,
        end: endTime,
    }));

    delete metrics[metricId];
}

export function* measure<T>(category: string, action: string, func: () => T) {
    const metricId = yield call(startMetric, category, action);
    try {
        return func();
    }
    finally {
        yield fork(endMetric, metricId);
    }
}